<template>
  <div>
    <Dialog class="p-dialog"
      :visible.sync="carregarTela"
      :closable="false"
      :modal="true"
      header="Aguarde"
    >
      <ProgressSpinner style="width:50px;height:50px" strokeWidth="10" fill="var(--surface-ground)" animationDuration="1s"/>
    </Dialog>
  </div>
</template>

<script>
export default {
  computed: {
    carregarTela() {
      return this.$store.state.dlgLoading;
    },
  },
};
</script>